import React from "react";
import { connect } from "react-redux";
import { tempAlWait } from "../helpers";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faEllipsisVertical, faEye, faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { codeProjectDelete, codeProjectSave } from "../actions/project";

class AdminItemProject extends React.Component {
    state = {
        optActive: false,
        isEdit: false,
        name: ''
    }

    componentDidMount() {
        this.setState({
            name: this.props.data.name
        })
    }
    
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.redCdPrDel != this.props.redCdPrDel) {
            this.props.changeAlert(this.props.redCdPrDel.alert);

            if (this.props.redCdPrDel.isNext) {
                this.props.refreshList(true);
            }
        }

        if (prevProps.redCdPrSave != this.props.redCdPrSave) {
            this.props.changeAlert(this.props.redCdPrSave.alert);

            if (this.props.redCdPrSave.isNext) {
                this.setState({
                    isEdit: false
                })
            }
        }
    }

    handleDelete(id) {
        if (window.confirm("Souhaitez-vous réellement supprimer ce projet ?")) {
            this.props.changeAlert(tempAlWait());
            this.props.codeProjectDelete({idProject: id});
        }
    }

    handleSubmitName() {
        this.props.codeProjectSave({
            idProject: this.props.data.id,
            name: this.state.name
        })
        this.props.changeAlert(tempAlWait());
    }

    render() {
        return <li className="admin__item admin__item--gall">
            {/** Id **/}
            <span className="admin__item__id">{this.props.data.id}</span>

            {/** Nom **/}
            <div className="admin__item__blogimg">
                {
                    this.state.isEdit ?
                        <div className="admin__item__formline">
                            <input
                                value={this.state.name}
                                onChange={(el) => this.setState({name: el.target.value})}
                                className="admin__item__inputline"
                                title="Nom du projet"
                                aria-label="Nom du projet"
                            />
                            <button
                                title="Enregistrer le nom"
                                aria-label="Enregistrer le nom"
                                className="admin__item__eyebtn"
                                onClick={() => this.handleSubmitName()}
                            >
                                <FontAwesomeIcon icon={faCheck} />
                            </button>
                        </div> :
                        <p className="admin__item__text">
                            {this.state.name}
                        </p>
                }
            </div>

            {/** Description **/}
            <span className="admin__item__desc"></span>

            {/** Options **/}
            <div className={`admin__item__opts ${this.state.optActive && "admin__item__opts--active"}`}>
                {/** Modifier **/}
                <button
                    title="Modifier le projet"
                    aria-label="Modifier le projet"
                    className="admin__item__optbtn"
                    onClick={() => this.setState({isEdit: !this.state.isEdit})}
                >
                    <FontAwesomeIcon icon={faPen} />
                </button>

                {/** Vue **/}
                <Link
                    title="Ouvrir le projet"
                    aria-label="Ouvrir le projet"
                    className="admin__item__optbtn"
                    to={`/admin/project/${this.props.data.id}`}
                >
                    <FontAwesomeIcon icon={faEye} />
                </Link>

                {/** Supprimer **/}
                <button
                    title="Supprimer le projet"
                    aria-label="Supprimer le projet"
                    className="admin__item__optbtn admin__item__optbtn--del"
                    onClick={() => this.handleDelete(this.props.data.id)}
                >
                    <FontAwesomeIcon icon={faTrashCan} />
                </button>
            </div>

            {/** Options bouton **/}
            <button
                title={this.state.optActive ? "Fermer les options" : "Ouvrir les options"}
                aria-label={this.state.optActive ? "Fermer les options" : "Ouvrir les options"}
                className="admin__item__btnopt"
                onClick={() => this.setState({optActive: !this.state.optActive})}
            >
                <FontAwesomeIcon icon={faEllipsisVertical} />
            </button>
        </li>
    }
}

const mapStateToProps = state => {
    return {
        redCdPrDel: state.redCdPrDel,
        redCdPrSave: state.redCdPrSave
    }
}

const mapDispatchToProps = {
    codeProjectDelete,
    codeProjectSave
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminItemProject);